import React, { useEffect, useState } from "react";

import { Container } from "components";
import Footer from "components/footer";
import { AgCharts } from "ag-charts-react";
import api from "services/api";
import moment from "moment";
import Pagination from "components/pagination";
import { useNavigate } from "react-router-dom";

export const Home = () => {

  const [getDash ,setGetDash] = useState({});
  const [chartOptions , setChartOptions] = useState({});
  const [salesChartOptions, setSalesChartOptions] = useState({})
  const [earningReport , SetEarningReport] = useState({})
  const [membershipsDetails, setMembershipsDetails] = useState([]);
  const [currentPage , SetCurrentPage ] = useState(1);
  const [isViewClicked, setIsViewClicked] = useState(false);
  const navigate = useNavigate();
    const [showKyc, SetShowKyc] = useState([]);
  
  const getDashBoardAdmin = async () => {
    try {
      const response = await api.get('/admin-dashboard');
      const list = response?.data?.data[0];
      setGetDash(list)
      console.log("getDashBoardAdmin:",list);

      const chartData = list?.no_of_user_registered_per_month?.map(item => ({
        month: item.month_year,
        registrations: item.total_users,
      }));
      const salesData = list?.no_of_sales_per_month?.map( (item) => ({
        month: item?.month_name,
        sales:  item.transaction_count ,
      }))
      const earningData = list?.earning_report?.map( (item) => ({
        month: item?.month_name,
        sales:   Number(item?.total_amount) || 0,
      }))
       // Update chart options
       setChartOptions({
        data: chartData || [],
        series: [
          {
            type: 'bar',
            xKey: 'month',
            yKey: 'registrations',
            fillOpacity: 0.8,
            strokeOpacity: 0.9,
            radius: 30, // Adds a top radius
            paddingInner: 0.3, // Reduces bar width
            paddingOuter: 0.2,
          },
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
          },
          {
            type: 'number',
            position: 'left',
          },
        ],
        legend: {
          enabled: false, // Disable legend if not needed
        },
      });
      // sales
      setSalesChartOptions({
        data: salesData || [],
        series: [
          {
            type: 'bar',
            xKey: 'month',
            yKey: 'sales',
            fillOpacity: 0.8,
            strokeOpacity: 0.9,
            radius: 30,
            paddingInner: 0.3,
            paddingOuter: 0.2,
          },
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
          },
          {
            type: 'number',
            position: 'left',
          },
        ],
        legend: {
          enabled: false,
        },
      });
      // earning report
      SetEarningReport({
        data: earningData || [],
        series: [
          {
            type: 'bar',
            xKey: 'month',
            yKey: 'sales',
            fillOpacity: 0.8,
            strokeOpacity: 0.9,
            radius: 30,
            paddingInner: 0.3,
            paddingOuter: 0.2,
          },
        ],
        axes: [
          {
            type: 'category',
            position: 'bottom',
          },
          {
            type: 'number',
            position: 'left',
          },
        ],
        legend: {
          enabled: false,
        },
      });

    } catch (error) {
      console.log("getDashBoardAdmin error:",error);
      
    }
  }
    const fetchMembershipDatails = async (page=1) => {
      try {
        const response = await api.get(`/membership-application?status=In-Progress&page=${page}`);
        const details = response?.data?.data;
        SetCurrentPage(page);
        setMembershipsDetails(details)
        console.log("fetchMembershipDatails:", details);
      } catch (error) {
        console.log("fetchMembershipDatails error:", error);
      }
    };
      const fetchKycData = async () => {
        try {
          const response = await api.get(`/kyc?status=Pending`);
          const kyclist = response?.data?.data;
          console.log("fetchKycData:", kyclist);
          SetShowKyc(kyclist);
        } catch (error) {
          console.log("fetchKycData Error:", error);
        }
      };
  useEffect( () => {
    getDashBoardAdmin();
    fetchMembershipDatails(1);
    fetchKycData();
  },[])
  const navigateFunction = (index) => {
    console .log(showKyc?.kyc[index]);
    const data = showKyc?.kyc[index];
    navigate("/confirmation",{ state: {data, isViewClicked: true }})
  }
  return (
    <Container>
      <div class="content-wrapper">
        <div class="container-xxl flex-grow-1 container-p-y">
          <h4 className="card-header">Dashboard</h4>
          <div class="row">
            <div class="col-sm-6 col-lg-3 mb-4">
              <div class="card card-border-shadow-primary">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2 pb-1">
                    <div class="avatar me-2">
                      <span class="avatar-initial rounded bg-label-primary">
                        <i class="ti ti-users ti-md"></i>
                      </span>
                    </div>
                    <h4 class="ms-1 mb-0">{getDash?.no_of_users}</h4>
                  </div>
                  <p class="mb-1">Number of users</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
              <div class="card card-border-shadow-success">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2 pb-1">
                    <div class="avatar me-2">
                      <span class="avatar-initial rounded bg-label-success">
                        <i class="ti ti-users ti-md"></i>
                      </span>
                    </div>
                    <h4 class="ms-1 mb-0">{getDash?.no_of_active_users}</h4>
                  </div>
                  <p class="mb-1">Number of active users</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
              <div class="card card-border-shadow-danger">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2 pb-1">
                    <div class="avatar me-2">
                      <span class="avatar-initial rounded bg-label-danger">
                        <i class="ti ti-users ti-md"></i>
                      </span>
                    </div>
                    <h4 class="ms-1 mb-0">{getDash?.no_of_inactive_users}</h4>
                  </div>
                  <p class="mb-1">Number of inactive users</p>
                </div>
              </div>
            </div>
            <div class="col-sm-6 col-lg-3 mb-4">
              <div class="card card-border-shadow-info">
                <div class="card-body">
                  <div class="d-flex align-items-center mb-2 pb-1">
                    <div class="avatar me-2">
                      <span class="avatar-initial rounded bg-label-info">
                        <i class="ti ti-chart-bar ti-md"></i>
                      </span>
                    </div>
                    <h4 class="ms-1 mb-0">{getDash?.total_sales}</h4>
                  </div>
                  <p class="mb-1">Total sales</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-12 mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="mb-0">No of Registrations</h5>
                  <small class="text-muted">
                    Last 12 Months Users Registrations Overview
                  </small>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0 ms-0 ms-sm-2">
                  <div
                    class="tab-pane fade show active"
                    id="navs-orders-id"
                    role="tabpanel">
                    {chartOptions.data && (
                      <AgCharts options={chartOptions} />
                    )}
                  </div>
                  <div class="tab-pane fade" id="navs-sales-id" role="tabpanel">
                    <div id="earningReportsTabsSales"></div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="navs-profit-id"
                    role="tabpanel"
                  >
                    <div id="earningReportsTabsProfit"></div>
                  </div>
                  <div
                    class="tab-pane fade"
                    id="navs-income-id"
                    role="tabpanel">
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-12 mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="mb-0">No of Sales</h5>
                  <small class="text-muted">
                  Last 12 Months No of Sales Overview
                  </small>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0 ms-0 ms-sm-2">
                  <div
                    class="tab-pane fade show active"
                    id="navs-orders-id"
                    role="tabpanel">
                    {salesChartOptions.data && (
                      <AgCharts options={salesChartOptions}/>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-12 mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="mb-0">Earning Report</h5>
                  <small class="text-muted">
                  Last 12 Months No of Earning Overview
                  </small>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0 ms-0 ms-sm-2">
                  <div
                    class="tab-pane fade show active"
                    id="navs-orders-id"
                    role="tabpanel" >
                    {earningReport.data && (
                      <AgCharts options={earningReport} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-12 mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="mb-0">Pending Membership approvals</h5>
                  <small class="text-muted">
                  </small>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0 ms-0 ms-sm-2">
                  <div className="card-datatable table-responsive">
                    <table className="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>First Name</th>
                          <th>Middle Name</th>
                          <th>Last Name</th>
                          <th className="text-truncate">Relation</th>
                          <th className="text-truncate">Status</th>
                          <th>PLAN NAME</th>
                          <th>APPLICATION NUMBER</th>
                          <th class="text-truncate">Purchase Date</th>
                          <th class="text-truncate">Valid Till</th>
                          <th class="cell-fit">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {membershipsDetails?.memberApplication?.slice().sort((a, b) => {
                            return new Date(b.updated_at) - new Date(a.updated_at);}).map((res ,index) => {
                          const serialNumber = (currentPage - 1) * membershipsDetails?.pagination?.per_page + (index + 1);
                          return (
                            <tr>
                              <td>{serialNumber}</td>
                              <td>{res.first_name}</td>
                              <td>{res.middle_name? res.middle_name : " "}</td>
                              <td>{res.last_name ? res.last_name : " "}</td>
                              <td>{res.relation}</td>
                              <td>
                                <span
                                  className={`badge ${
                                    res.status === "Pending"
                                      ? "bg-warning"
                                      : res.status === "Approved"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  {res.status}
                                </span>
                              </td>
                              <td>{res.membership_plan.title}</td>
                              <td>{res.application_no}</td>
                              <td>{res.updated_at?moment(res.updated_at).format("DD-MM-YYYY") : " "}</td>
                              <td>{res.end_date?moment(res.end_date).format("DD-MM-YYYY") : " "}</td>
                              <td>
                                <button
                                  variant="outlined"
                                  className="btn btn-primary"
                                  onClick={() =>
                                    navigate(`/membershipDetailsCard/${res.application_no}`,{ state: { isViewClicked: true }})
                                  }
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                    {membershipsDetails?.pagination?.total > 0 && <Pagination totalPages={membershipsDetails?.pagination?.total} perPage={membershipsDetails?.pagination?.per_page} handleFunction={fetchMembershipDatails}/>}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 col-xl-12 mb-4">
            <div class="card">
              <div class="card-header d-flex justify-content-between">
                <div class="card-title mb-0">
                  <h5 class="mb-0">Pending KYC approvals</h5>
                  <small class="text-muted">
                  </small>
                </div>
              </div>
              <div class="card-body">
                <div class="tab-content p-0 ms-0 ms-sm-2">
                  <div className="card-datatable table-responsive">
                    <table className="invoice-list-table table border-top dataTable no-footer dtr-column mb-5">
                      <thead>
                        <tr>
                          <th>Sno</th>
                          <th>Profile</th>
                          <th className="text-truncate">Relation</th>
                          <th>Aadhaar Number</th>
                          <th>Submitted on </th>
                          <th className="text-truncate">Verified on</th>
                          <th className="text-truncate">KYC Status</th>
                          <th className="cell-fit">Verify</th>
                        </tr>
                      </thead>
                      <tbody>
                        {showKyc?.kyc?.slice().sort((a,b)=>{
                            return new Date(b.updated_at) - new Date(b.updated_at);})
                            .map((entry ,index) => {
                          const serialNumber = (currentPage - 1) * membershipsDetails?.pagination?.per_page + (index + 1);
                          return (
                            <tr key={index}>
                              <td>{serialNumber}</td>
                              <td>
                                    {
                                      <img
                                        src={entry?.user_image}
                                        style={{
                                          width: "40px",
                                          height: "40px",
                                          borderRadius: "50%",
                                        }}
                                      />
                                    }
                                  </td>
                              <td>{entry?.relation}</td>
                              <td>{entry?.aadhar_number}</td>
                              <td>
                                {moment(entry?.created_at).format(
                                  "DD-MM-YYYY"
                                )}
                              </td>
                              <td>{entry?.verified_at? moment(entry?.verified_at).format("DD-MM-YYYY"): "--"}</td>
                              <td>
                                <button
                                  className={`badge border-0 ${
                                    entry?.status === "Pending"
                                      ? "bg-warning"
                                      : entry?.status === "Approved"
                                      ? "bg-success"
                                      : "bg-danger"
                                  }`}
                                >
                                  <span>{entry?.status}</span>
                                </button>
                              </td>
                              <td>
                                <button
                                  variant="outlined"
                                  className="btn btn-primary"
                                  onClick={() => {
                                    navigateFunction(index)
                                  }}
                                >
                                  View
                                </button>
                              </td>
                            </tr>
                          )
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="content-backdrop fade"></div>
      </div>
    </Container>
  );
};
